import gql from 'graphql-tag';

export default gql`
    mutation DeleteJobLog($input: DeleteJobLogInput) {
        deleteJobLog(input: $input) {
            errors
        }
    }
`;
